import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OnboardingPipe } from './onboarding.pipe';


@NgModule({
  declarations: [
    OnboardingPipe,
  ],
  exports: [
    OnboardingPipe,
  ],
  imports: [
    CommonModule,
  ],
})
export class OnboardingModule { }
